<script>
  import { afterUpdate } from "svelte"
  import LocationCard from "./locationCard.svelte"
  import { loadTooltip } from "../../../../Script/loadTooltip"

  export let json

  let location = json.location ? JSON.parse(json.location) : ""
  let IPDetails = false

  afterUpdate(() => {
    loadTooltip()
    window.addEventListener("resize", loadTooltip)
  })
</script>

<!-- <div class="mx-auto mt-3 flex h-full w-full flex-col gap-3 rounded-md bg-[#f7f7f7] px-6 py-3 hover:scale-y-110 hover:shadow-md dark:bg-darkgray dark:hover:shadow-lightgray"> -->

<div class="flex w-full cursor-pointer items-center justify-between gap-3 rounded-md bg-[#f7f7f7] p-3 text-gray-200 hover:shadow-md dark:border-2 dark:border-transparent dark:bg-lightgray dark:hover:border-blue-500">
  <div class="w-8/12 space-y-1.5">
    <div class="flex gap-3">
      <button on:click={() => (IPDetails = true)} class="min-w-[120px] truncate text-start text-xs font-semibold text-black hover:text-blue-500 active:text-blue-500 dark:text-white dark:hover:text-blue-500 dark:active:text-blue-500 sm:text-base">{json.ip}</button>
      {#if location.city}
        <div class=" hidden cursor-pointer items-center justify-center gap-1.5 px-1.5 text-sm font-medium text-gray-500 md:flex">
          {#if location.countryCode}
            <span class="flag flag-{location.countryCode.toLowerCase()}  overflow-hidden" />
          {:else}
            <i class="fa-solid fa-earth-americas" />
          {/if}
          <span class="w-28 truncate text-xs hover:text-blue-500 sm:text-base">{location.country}</span>
        </div>
        <div class=" hidden cursor-pointer items-center justify-center gap-1.5 px-1.5 text-sm font-medium text-gray-500 md:flex">
          <i class="fa-solid fa-city" />
          <span class="w-28 truncate text-xs hover:text-blue-500 sm:text-base">{location.city}</span>
        </div>
      {/if}
    </div>
    <p class="font select-none text-xs font-normal text-gray-200 sm:text-base">
      <i class="fa-solid fa-calendar-days" />
      &nbsp;&nbsp;{new Date(json.date).toString().slice(0, 24)}
    </p>
  </div>
  <div class="flex w-4/12 select-none justify-end gap-3">
    <button name="tooltip" id="Location info" tooltip-position="top" on:click|stopPropagation|preventDefault={() => (IPDetails = true)} class="flex cursor-pointer items-center justify-center gap-3 rounded-full py-2 px-1.5 text-sm font-medium text-yellow-500 hover:bg-yellow-500 hover:text-white active:bg-yellow-600 sm:px-3 md:px-5">
      <i class="fa-solid fa-circle-info" />
      <span class="hidden w-max lg:block">Location info</span>
    </button>
  </div>
</div>
{#if IPDetails}
  <LocationCard {json} {location} on:click={() => (IPDetails = false)} />
{/if}

<!-- </div> -->

<style>
  ::-webkit-scrollbar-thumb {
    background: #f7f7f7;
    border-radius: 20px;
  }
  ::-webkit-scrollbar {
    height: 4px;
  }
</style>
